module.exports = __webpack_public_path__ + "img/paper.c3933f1f.svg";